import React from 'react';

interface LogoProps {
  className?: string;
  wordmark?: boolean;
  inverse?: boolean;
}

export default function Logo({ className = '', wordmark = false, inverse = false }: LogoProps) {
  return (
    <span className={`brand-lockup ${inverse ? 'is-inverse' : ''} ${wordmark ? className : ''}`}>
      <svg
        className={`brand-mark ${wordmark ? '' : className}`}
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden="true"
      >
        {/* C — Clair */}
        <path
          d="M33.2 12.4C28.6 7.6 21.4 6.4 15.6 10.2 8.6 14.8 6.8 24 11.6 31.4 16.2 38.4 26 40.6 33.2 35.6"
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
        />
        {/* I — le trait qui clarifie */}
        <rect x="34.15" y="14.2" width="2.7" height="19.6" rx="1.35" fill="currentColor" className="brand-beam-stem" />
        <circle cx="35.5" cy="11.1" r="1.85" fill="#E2C48A" />
      </svg>
      {wordmark && (
        <span className="brand-word">
          <span className="brand-clair">Clair</span>
          <span className="brand-ify">ify</span>
        </span>
      )}
    </span>
  );
}
